<div class="dialog-content-wrapper" fusePerfectScrollbar>
  <mat-toolbar class="mat-accent m-0">
    <mat-toolbar-row class="flex flex-row justify-between items-center">
      <span i18n class="title dialog-title">Замена облицовки</span>
      <button mat-button class="mat-icon-button" (click)="dialogRef.close(undefined)" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="p-0 pb-0 m-0" fusePerfectScrollbar>
    <ng-container>
      <mat-table #table [dataSource]="dataSource" class="butt-replacement-table" fusePerfectScrollbar>
        <!-- Old Butt Column -->
        <ng-container matColumnDef="oldButt">
          <mat-header-cell i18n *matHeaderCellDef>Текущая облицовка</mat-header-cell>
          <mat-cell *matCellDef="let item">
            <p class="text-truncate">{{ item.oldButt.sign }} ({{ item.oldButt.thickness }}mm)</p>
          </mat-cell>
        </ng-container>

        <!-- New Butt Column -->
        <ng-container matColumnDef="newButt">
          <mat-header-cell i18n *matHeaderCellDef>Новая облицовка</mat-header-cell>
          <mat-cell *matCellDef="let item">
            <mat-form-field appearance="outline" class="w-full mini-input no-subscript no-label">
              <mat-select [(ngModel)]="item.newButt" #newButtSelect>
                <mat-option [value]="item.oldButt">
                  {{ item.oldButt.sign }} ({{ item.oldButt.thickness }}mm)
                </mat-option>

                <mat-option *ngFor="let otherButt of otherButts" [value]="otherButt">
                  {{ otherButt.sign }} ({{ otherButt.thickness }}mm)
                </mat-option>

                <mat-option *ngFor="let buttInColor of buttsInColorList" [value]="buttInColor">
                  {{ buttInColor.sign }} ({{ buttInColor.thickness }}mm)
                </mat-option>

                <mat-option
                  i18n
                  [value]="item.newButt"
                  *ngIf="useMatBase()"
                  (click)="setButtFromMatBase(item, newButtSelect)"
                  >Другая…</mat-option
                >
              </mat-select>
            </mat-form-field>
          </mat-cell>
        </ng-container>

        <!-- Panel Thickness Column -->
        <ng-container matColumnDef="panelThickness">
          <mat-header-cell class="pl-2" i18n *matHeaderCellDef>Толщина панели</mat-header-cell>
          <mat-cell class="pl-2 justify-center" *matCellDef="let item">
            {{ item.panelThickness }}
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row class="butt-replacement-row" *matRowDef="let item; columns: displayedColumns"></mat-row>
      </mat-table>
    </ng-container>
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-actions class="flex flex-row justify-end items-center m-0 p-4">
    <button i18n mat-raised-button class="mat-accent mr-4" (click)="saveAndClose()">ОК</button>
    <button i18n mat-button (click)="dialogRef.close(undefined)">Отмена</button>
  </div>
</div>
